import { isArray, isEmpty, isPlainObject } from 'lodash';

class VerticalCertingModel {
  static initialVerticals(verticalsFromResponse = {}) {
    if (isPlainObject(verticalsFromResponse) && !isEmpty(verticalsFromResponse)) {
      return Object.entries(verticalsFromResponse).map(([vertical, website]) => {
        return {
          vertical,
          website: website,
        };
      });
    }

    return [];
  }

  static parseRequestFromListToObj(verticals = []) {
    if (isArray(verticals)) {
      return verticals
        .filter((el) => !!el.vertical)
        .reduce((nextObj, el) => {
          nextObj = {
            ...nextObj,
            [el.vertical]: el.website,
          };

          return nextObj;
        }, {});
    }

    return {};
  }
}

export default VerticalCertingModel;
